(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[656,673],{

/***/ 43503:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resort/[resort]",
      function () {
        return __webpack_require__(28862);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var context_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40714);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function EditLink(_param) {
    var setEditOpen = _param.setEditOpen, props = _objectWithoutProperties(_param, [
        "setEditOpen"
    ]);
    var user = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_app__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).user;
    if (!(user === null || user === void 0 ? void 0 : user.CanAccessAdmin)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: "overflow-hidden bg-white px-4 py-4 shadow sm:rounded-md sm:px-6",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", _objectSpread({
            type: "button",
            className: "inline-flex items-center rounded-md border border-transparent bg-red-600 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2",
            onClick: function() {
                return setEditOpen(true);
            }
        }, props, {
            children: "Edit"
        }))
    });
};


/***/ }),

/***/ 43738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Config; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);
/* harmony import */ var utils_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92233);



function Config(param) {
    var children = param.children, fallback = param.fallback;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swr__WEBPACK_IMPORTED_MODULE_1__/* .SWRConfig */ .J$, {
        value: {
            refreshInterval: 1000 * 60 * 2,
            fetcher: function(q, variables) {
                return (0,utils_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(q, variables);
            },
            fallback: fallback
        },
        children: children
    });
};


/***/ }),

/***/ 45033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Attributes; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_attributeKeyMap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71100);



function Attributes(param) {
    var attributes = param.attributes, title = param.title;
    if (!Array.isArray(attributes) || !attributes.length) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: "overflow-hidden bg-white px-4 py-4 shadow sm:rounded-md sm:px-6",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-4 py-5 sm:px-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-lg font-medium leading-6 text-gray-900",
                    children: title !== null && title !== void 0 ? title : "Attributes"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "border-t border-gray-200 px-4 py-5 sm:p-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dl", {
                    className: "sm:divide-y sm:divide-gray-200",
                    children: attributes.map(function(attribute) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                                    className: "text-sm font-medium text-gray-500",
                                    children: utils_attributeKeyMap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[attribute.ValueType] || attribute.ValueType
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                    className: "mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0",
                                    children: attribute.Link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: attribute.Link,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: attribute.Link,
                                            className: "no-underline hover:underline",
                                            children: attribute.Value
                                        })
                                    }) : attribute.Value
                                })
                            ]
                        }, attribute.ValueType);
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 43228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25575);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);

/* eslint-disable react/no-array-index-key */ 


function Pagination(param) {
    var items = param.items;
    var pages = items || [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        className: "mb-10 flex",
        "aria-label": "Breadcrumb",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
            className: "flex space-x-4 rounded-md bg-white px-6 shadow",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "flex",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "text-gray-400 hover:text-gray-500",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        className: "h-5 w-5 flex-shrink-0",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "sr-only",
                                        children: "Home"
                                    })
                                ]
                            })
                        })
                    })
                }),
                pages.map(function(page, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                            "flex last-of-type:hidden md:last-of-type:flex": pages.length > 1
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "h-full w-6 flex-shrink-0 text-gray-200",
                                    viewBox: "0 0 24 44",
                                    preserveAspectRatio: "none",
                                    fill: "currentColor",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M.293 0l22 22-22 22h1.414l22-22-22-22H.293z"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: page.linkAs,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "ml-4 text-sm font-medium text-gray-500 hover:text-gray-700",
                                        "aria-current": page.current ? "page" : undefined,
                                        children: page.name
                                    })
                                })
                            ]
                        })
                    }, "breadcrumb-".concat(page.name, "-").concat(index));
                })
            ]
        })
    });
};


/***/ }),

/***/ 13693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/solid/esm/GlobeAltIcon.js


function GlobeAltIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react.forwardRef(GlobeAltIcon);
/* harmony default export */ var esm_GlobeAltIcon = (ForwardRef);
// EXTERNAL MODULE: ./context/app.js
var app = __webpack_require__(40714);
// EXTERNAL MODULE: ./components/global/card.module.css
var card_module = __webpack_require__(49969);
var card_module_default = /*#__PURE__*/__webpack_require__.n(card_module);
;// CONCATENATED MODULE: ./components/global/card.jsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

/* eslint-disable @next/next/no-img-element */ 




function Card(_param) {
    var props = _extends({}, _param);
    var link = props.link, image = props.image, title = props.title, type = props.type, additional = props.additional, location = props.location;
    var user = (0,react.useContext)(app/* default */.Z).user;
    // hack
    var isRestroom = title.toLowerCase().includes("restroom");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "group relative block",
            children: [
                (user === null || user === void 0 ? void 0 : user.CanAccessAdmin) && (location === null || location === void 0 ? void 0 : location.Latitude) && (location === null || location === void 0 ? void 0 : location.Longitude) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-0 right-0 z-10 rounded-tr rounded-bl bg-blue-500 p-2",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_GlobeAltIcon, {
                        className: "h-4 w-4 fill-white"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "aria-hidden": "true",
                    className: "aspect-w-16 aspect-h-9 overflow-hidden rounded-lg group-hover:opacity-75",
                    children: image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://images.opencoaster.com/800x400/".concat(image.hash).concat(image.ext),
                        srcSet: "\n                https://images.opencoaster.com/800x400/".concat(image.hash).concat(image.ext, " 800w,\n                https://images.opencoaster.com/600x300/").concat(image.hash).concat(image.ext, " 600w,\n                https://images.opencoaster.com/400x200/").concat(image.hash).concat(image.ext, " 400w,\n                https://images.opencoaster.com/300x150/").concat(image.hash).concat(image.ext, " 300w,\n                https://images.opencoaster.com/200x100/").concat(image.hash).concat(image.ext, " 200w,\n                https://images.opencoaster.com/100x50/").concat(image.hash).concat(image.ext, " 100w\n              "),
                        alt: image.alternativeText ? image.alternativeText : title,
                        className: "h-full w-full object-cover object-center"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-full w-full bg-gray-200 object-cover object-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center ".concat((card_module_default()).contents),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "flex",
                                src: "/placeholder-".concat(isRestroom ? "restroom" : type, ".svg"),
                                alt: title
                            })
                        })
                    })
                }),
                additional && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-3 text-sm text-gray-500",
                    children: additional
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-base font-semibold text-gray-900 ".concat(!additional ? "mt-3" : ""),
                    children: title
                })
            ]
        })
    });
};


/***/ }),

/***/ 16763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var context_app__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40714);
/* harmony import */ var _cover_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14102);
/* harmony import */ var _cover_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_cover_module_css__WEBPACK_IMPORTED_MODULE_4__);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

/* eslint-disable @next/next/no-img-element */ 



var Cover = function(_param) {
    var props = _extends({}, _param);
    var title = props.title, classes = props.classes, image = props.image;
    var setTransparentHeader = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_app__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).setTransparentHeader;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setTransparentHeader(true);
        return function() {
            setTransparentHeader(false);
        };
    }, [
        setTransparentHeader
    ]);
    var titleHtml = null;
    if (title) {
        titleHtml = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mb-3 text-3xl font-bold text-white lg:text-5xl"),
            children: title
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("relative w-full bg-black", (_cover_module_css__WEBPACK_IMPORTED_MODULE_4___default().cover), classes),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute inset-0 bottom-0 w-full", (_cover_module_css__WEBPACK_IMPORTED_MODULE_4___default().figure)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "w-full object-cover object-center",
                        src: "https://images.opencoaster.com/767x250/".concat(image.hash).concat(image.ext),
                        alt: image.alternativeText ? image.alternativeText : title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute bottom-0 right-0 p-1 font-mono text-white text-opacity-75 transition-opacity duration-200 ease-in-out", (_cover_module_css__WEBPACK_IMPORTED_MODULE_4___default().caption)),
                        children: image.caption
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_cover_module_css__WEBPACK_IMPORTED_MODULE_4___default().titleBg), "relative w-full pb-2 pt-20"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container mx-auto px-6 sm:px-0",
                    children: titleHtml
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Cover);


/***/ }),

/***/ 36551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);


function Throw404() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_1__["default"], {
        statusCode: 404
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Throw404);


/***/ }),

/***/ 28862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Resort; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/config.jsx
var config = __webpack_require__(43738);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./components/throw404.jsx
var throw404 = __webpack_require__(36551);
// EXTERNAL MODULE: ./components/global/card.jsx + 1 modules
var card = __webpack_require__(13693);
// EXTERNAL MODULE: ./components/global/cover.jsx
var cover = __webpack_require__(16763);
// EXTERNAL MODULE: ./components/global/breadcrumbs.jsx
var global_breadcrumbs = __webpack_require__(43228);
// EXTERNAL MODULE: ./components/global/attributes.jsx
var global_attributes = __webpack_require__(45033);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(11355);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 9 modules
var dialog = __webpack_require__(7216);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/XIcon.js
var XIcon = __webpack_require__(5506);
// EXTERNAL MODULE: ./utils/saveEdit.js
var saveEdit = __webpack_require__(28);
;// CONCATENATED MODULE: ./components/resorts/edit.jsx
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}

/* eslint-disable @next/next/no-img-element */ 




function EditResortPanel(param1) {
    var open = param1.open, setOpen = param1.setOpen, resort = param1.resort;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
        show: open,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.V, {
            as: "div",
            className: "fixed inset-0 z-30 overflow-hidden",
            onClose: setOpen,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute inset-0 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Overlay */.V.Overlay, {
                        className: "absolute inset-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "transform transition ease-in-out duration-500 sm:duration-700",
                            enterFrom: "translate-x-full",
                            enterTo: "translate-x-0",
                            leave: "transform transition ease-in-out duration-500 sm:duration-700",
                            leaveFrom: "translate-x-0",
                            leaveTo: "translate-x-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-screen max-w-2xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                                    initialValues: {
                                        resortName: resort.Name,
                                        mainImage: resort.MainPhoto,
                                        mainImageCaption: ((ref1 = resort.MainPhoto) === null || ref1 === void 0 ? void 0 : ref1.caption) || ""
                                    },
                                    onSubmit: function(values, param) {
                                        var setSubmitting = param.setSubmitting;
                                        return (0,saveEdit/* default */.Z)(values, setSubmitting, resort, setOpen);
                                    },
                                    children: function(param) {
                                        var values = param.values, errors = param.errors, touched = param.touched, handleChange = param.handleChange, handleBlur = param.handleBlur, handleSubmit = param.handleSubmit, setFieldValue = param.setFieldValue, isSubmitting = param.isSubmitting;
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
                                            className: "flex h-full flex-col overflow-y-scroll bg-white shadow-xl",
                                            onSubmit: handleSubmit,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "bg-gray-50 px-4 py-6 sm:px-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex items-start justify-between space-x-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "space-y-1",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Title */.V.Title, {
                                                                            className: "text-lg font-medium text-gray-900",
                                                                            children: "Edit Resort"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "flex h-7 items-center",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                            type: "button",
                                                                            className: "text-gray-400 hover:text-gray-500",
                                                                            onClick: function() {
                                                                                return setOpen(false);
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "sr-only",
                                                                                    children: "Close panel"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
                                                                                    className: "h-6 w-6",
                                                                                    "aria-hidden": "true"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "resortName",
                                                                                className: "block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2",
                                                                                children: "Resort name"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "sm:col-span-2",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                type: "text",
                                                                                name: "resortName",
                                                                                id: "resortName",
                                                                                className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                                                                onChange: handleChange,
                                                                                onBlur: handleBlur,
                                                                                value: values.resortName
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "mainImage",
                                                                                className: "block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2",
                                                                                children: "Main Image"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "sm:col-span-2",
                                                                            children: [
                                                                                (values === null || values === void 0 ? void 0 : (ref = values.mainImage) === null || ref === void 0 ? void 0 : ref.hash) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "aspect-video relative mb-4 w-full",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: "https://images.opencoaster.com/800x400/".concat(values.mainImage.hash).concat(values.mainImage.ext),
                                                                                        alt: "",
                                                                                        loading: "lazy"
                                                                                    })
                                                                                }),
                                                                                _instanceof(values === null || values === void 0 ? void 0 : values.mainImage, File) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "aspect-video relative mb-4 w-full",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: URL.createObjectURL(values.mainImage),
                                                                                        alt: "",
                                                                                        loading: "lazy"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                    type: "file",
                                                                                    id: "mainImage",
                                                                                    name: "mainImage",
                                                                                    accept: "image/jpg,image/jpeg",
                                                                                    onChange: function(event) {
                                                                                        setFieldValue("mainImage", event.currentTarget.files[0]);
                                                                                    },
                                                                                    className: "mb-4"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "text-sm",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                            htmlFor: "mainImageCaption",
                                                                                            className: "font-medium text-gray-700",
                                                                                            children: "Caption"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                            type: "text",
                                                                                            name: "mainImageCaption",
                                                                                            id: "mainImageCaption",
                                                                                            className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                                                                            onChange: handleChange,
                                                                                            onBlur: handleBlur,
                                                                                            value: values.mainImageCaption
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex justify-end space-x-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                type: "button",
                                                                className: "rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                                                onClick: function() {
                                                                    return setOpen(false);
                                                                },
                                                                children: "Cancel"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                type: "submit",
                                                                className: "inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                                                disabled: isSubmitting,
                                                                children: "Save"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./components/admin/editlink.jsx
var editlink = __webpack_require__(32673);
// EXTERNAL MODULE: ./queries/resort.js
var queries_resort = __webpack_require__(20272);
;// CONCATENATED MODULE: ./components/resorts/resort-details.jsx













function ResortDetails() {
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), editOpen = ref1[0], setEditOpen = ref1[1];
    var variables = {
        slug: router.query.resort
    };
    var ref2 = (0,dist/* default */.ZP)([
        queries_resort/* default */.Z,
        variables
    ]), data = ref2.data, error = ref2.error;
    if (error) {
        console.log(error);
    }
    if (!Array.isArray(data === null || data === void 0 ? void 0 : data.resorts) || !(data === null || data === void 0 ? void 0 : (ref = data.resorts) === null || ref === void 0 ? void 0 : ref.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(throw404/* default */.Z, {});
    }
    var resort = data.resorts[0];
    var description = "Information on rides, shows and other attractions found at ".concat(resort.Name);
    var CoverPhoto = "";
    var ResortTitle = "";
    if (resort.CoverPhoto || resort.MainPhoto) {
        CoverPhoto = /*#__PURE__*/ (0,jsx_runtime.jsx)(cover/* default */.Z, {
            title: resort.Name,
            image: resort.CoverPhoto || resort.MainPhoto
        });
    } else {
        ResortTitle = /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
            className: "mb-10 font-serif text-5xl text-gray-800",
            children: resort.Name
        });
    }
    var attributes = [];
    // Todo handle these better, yuck
    if (resort.CurrentlyOperating) {
        attributes.push({
            ValueType: "Status",
            Value: resort.CurrentlyOperating ? "Operational" : "Closed"
        });
    }
    if (resort.OpeningDate) {
        attributes.push({
            ValueType: "Opening Date",
            Value: resort.OpeningDate
        });
    }
    if (resort.ClosedDate) {
        attributes.push({
            ValueType: "Date Closed",
            Value: resort.ClosedDate
        });
    }
    var breadcrumbs = [];
    if (Array.isArray(resort.Companies) && resort.Companies.length > 0) {
        var company = resort.Companies[0];
        breadcrumbs.push({
            name: company.Name,
            link: "/company/[company]",
            linkAs: "/company/".concat(company.Slug)
        });
    }
    breadcrumbs.push({
        name: resort.Name,
        link: "/resort/[resort]",
        linkAs: "/resort/".concat(resort.Slug)
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            resort.Name,
                            " | Open Coaster"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: resort.Name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://opencoaster.com/resort/".concat(resort.Slug)
                    }),
                    resort.MainPhoto && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: "https://images.opencoaster.com/1200x630/".concat(resort.MainPhoto.hash).concat(resort.MainPhoto.ext)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: "https://images.opencoaster.com/1200x600/".concat(resort.MainPhoto.hash).concat(resort.MainPhoto.ext)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image:width",
                                content: "1200"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image:height",
                                content: "630"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image:alt",
                                content: resort.MainPhoto.alternativeText ? resort.MainPhoto.alternativeText : resort.Name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:card",
                                content: "summary_large_image"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditResortPanel, {
                open: editOpen,
                setOpen: setEditOpen,
                resort: resort
            }),
            CoverPhoto,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "container m-6 mx-auto px-6 sm:px-0",
                children: [
                    ResortTitle,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_breadcrumbs/* default */.Z, {
                        items: breadcrumbs
                    }),
                    Array.isArray(resort.Parks) && resort.Parks.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mb-3 font-serif text-3xl text-gray-800",
                                children: resort.Parks.length > 1 ? "Parks" : "Park"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-10 grid grid-cols-2 gap-8 md:grid-cols-2 lg:grid-cols-4",
                                children: resort.Parks.map(function(park) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                                        link: "/park/".concat(park.Slug),
                                        title: park.Name,
                                        image: park.MainPhoto,
                                        type: "park",
                                        isTempClosed: park.IsTempClosed
                                    }, park.id);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "order-first md:order-last md:col-span-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            role: "list",
                            className: "space-y-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_attributes/* default */.Z, {
                                    attributes: attributes,
                                    title: "Key Facts"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(editlink["default"], {
                                    setEditOpen: setEditOpen
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/resort/[resort].jsx



var __N_SSG = true;
function Resort(param) {
    var fallback = param.fallback;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(config/* default */.Z, {
        fallback: fallback,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResortDetails, {})
    });
};


/***/ }),

/***/ 12722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ attraction; }
});

// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./queries/fragments/MainPhoto.js
var MainPhoto = __webpack_require__(20519);
// EXTERNAL MODULE: ./queries/fragments/ParkLite.js
var ParkLite = __webpack_require__(82202);
;// CONCATENATED MODULE: ./queries/fragments/AttractionAttribute.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment Attribute on ComponentAttractionAttribute {\n    __typename\n    ValueType\n    Value\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Attribute = (0,dist.gql)(_templateObject());
/* harmony default export */ var AttractionAttribute = (Attribute);

;// CONCATENATED MODULE: ./queries/attraction.js
function attraction_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function attraction_templateObject() {
    var data = attraction_taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  query Attraction($slug: String!) {\n    attractions(where: { Slug: $slug }) {\n      __typename\n      id\n      Slug\n      Name\n      Description\n      Type\n      Park {\n        ...ParkLite\n      }\n      CoverPhoto {\n        ...MainPhoto\n      }\n      MainPhoto {\n        ...MainPhoto\n      }\n      Attribute {\n        ...Attribute\n      }\n      Manufacturers {\n        Name\n        Slug\n      }\n      Gallery {\n        ...MainPhoto\n      }\n      Tags {\n        Name\n        Slug\n      }\n      Location {\n        Latitude\n        Longitude\n      }\n    }\n  }\n"
    ]);
    attraction_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ATTRACTION_QUERY = (0,dist.gql)(attraction_templateObject(), MainPhoto/* default */.Z, ParkLite/* default */.Z, AttractionAttribute);
/* harmony default export */ var attraction = (ATTRACTION_QUERY);


/***/ }),

/***/ 20519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MainPhoto on UploadFile {\n    caption\n    alternativeText\n    hash\n    ext\n    width\n    height\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MainPhoto = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (MainPhoto);


/***/ }),

/***/ 59147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var queries_fragments_MainPhoto__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20519);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  fragment ParkCard on Parks {\n    id\n    Name\n    Slug\n    CurrentlyOperating\n    IsTempClosed\n    MainPhoto {\n      ...MainPhoto\n    }\n    Location {\n      Latitude\n      Longitude\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ParkCard = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject(), queries_fragments_MainPhoto__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (ParkCard);


/***/ }),

/***/ 82202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ParkLite on Parks {\n    id\n    Name\n    Slug\n    MainPhoto {\n      ...MainPhoto\n    }\n    Resort {\n      id\n      Name\n      Slug\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ParkLite = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (ParkLite);


/***/ }),

/***/ 17221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment RichText on ComponentTextText {\n    __typename\n    Content\n    id\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var RichText = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (RichText);


/***/ }),

/***/ 89847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SectionHeader on ComponentTextSectionHeader {\n    __typename\n    Header\n    Anchor\n    id\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SectionHeader = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (SectionHeader);


/***/ }),

/***/ 41449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ park; }
});

// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./queries/fragments/MainPhoto.js
var MainPhoto = __webpack_require__(20519);
// EXTERNAL MODULE: ./queries/fragments/SectionHeader.js
var SectionHeader = __webpack_require__(89847);
// EXTERNAL MODULE: ./queries/fragments/RichText.js
var RichText = __webpack_require__(17221);
;// CONCATENATED MODULE: ./queries/fragments/AttractionCard.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AttractionCard on Attraction {\n    id\n    Slug\n    Name\n    Location {\n      Latitude\n      Longitude\n    }\n    MainPhoto {\n      ...MainPhoto\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var AttractionCard = (0,dist.gql)(_templateObject());
/* harmony default export */ var fragments_AttractionCard = (AttractionCard);

;// CONCATENATED MODULE: ./queries/park.js
function park_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function park_templateObject() {
    var data = park_taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  query Park($slug: String!) {\n    parks(where: { Slug: $slug }) {\n      __typename\n      id\n      Name\n      Slug\n      OpeningDate\n      ClosedDate\n      CurrentlyOperating\n      IsTempClosed\n      Type\n      Companies {\n        id\n        Name\n        Slug\n      }\n      Resort {\n        id\n        Name\n        Slug\n      }\n      Attractions {\n        ...AttractionCard\n      }\n      CoverPhoto {\n        ...MainPhoto\n      }\n      MainPhoto {\n        ...MainPhoto\n      }\n      Lands {\n        __typename\n        Name\n        Content\n        Attractions {\n          ...AttractionCard\n        }\n      }\n      Sections {\n        ...SectionHeader\n        ...RichText\n      }\n      SeasonalEvent {\n        id\n        Name\n        Description\n        StartDate\n        EndDate\n      }\n      Location {\n        Latitude\n        Longitude\n      }\n    }\n  }\n"
    ]);
    park_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var PARK_QUERY = (0,dist.gql)(park_templateObject(), MainPhoto/* default */.Z, SectionHeader/* default */.Z, RichText/* default */.Z, fragments_AttractionCard);
/* harmony default export */ var park = (PARK_QUERY);


/***/ }),

/***/ 20272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var queries_fragments_ParkCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59147);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  query Resort($slug: String!) {\n    resorts(where: { Slug: $slug }) {\n      __typename\n      id\n      Name\n      Slug\n      CoverPhoto {\n        ...MainPhoto\n      }\n      MainPhoto {\n        ...MainPhoto\n      }\n      Companies {\n        id\n        Name\n        Slug\n      }\n      Parks {\n        ...ParkCard\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var RESORT_QUERY = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject(), queries_fragments_ParkCard__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (RESORT_QUERY);


/***/ }),

/***/ 71100:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var ATTRIBUTES = {
    MANUFACTURER: "Manufacturer",
    CAPACITY: "Capacity",
    HEIGHT: "Height",
    MAX_SPEED: "Max Speed",
    HEIGHT_RESTRICTION: "Height Restriction",
    TRACK_LAYOUT: "Track Layout",
    INVERSIONS: "Inversions",
    LENGTH: "Length",
    DURATION: "Duration",
    ADMISSION_COST: "Admission Cost",
    PROPULSION: "Propulsion System",
    RESTRAINTS: "Restraints",
    DROP: "Drop"
};
/* harmony default export */ __webpack_exports__["Z"] = (ATTRIBUTES);


/***/ }),

/***/ 92233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ query1; }
/* harmony export */ });
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96519);


function query1(query, args) {
    var variables = args;
    var token;
    if (args === null || args === void 0 ? void 0 : args.variables) {
        variables = args.variables;
    }
    if ((args === null || args === void 0 ? void 0 : args.token) && typeof (args === null || args === void 0 ? void 0 : args.token) === "string") {
        token = args.token;
    }
    var client = new graphql_request__WEBPACK_IMPORTED_MODULE_0__.GraphQLClient(utils_const__WEBPACK_IMPORTED_MODULE_1__/* .GRAPH_URL */ .Vd);
    if (token) {
        client.setHeader("authorization", "Bearer ".concat(token));
    }
    return client.request(query, variables);
};


/***/ }),

/***/ 28:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ saveEdit; }
/* harmony export */ });
/* harmony import */ var _node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31955);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8100);
/* harmony import */ var utils_const__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96519);
/* harmony import */ var queries_attraction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12722);
/* harmony import */ var queries_resort__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20272);
/* harmony import */ var queries_park__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41449);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}








function saveEdit(values, setSubmitting, item, setOpen) {
    return _saveEdit.apply(this, arguments);
};
function _saveEdit() {
    _saveEdit = _asyncToGenerator(_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values, setSubmitting, item, setOpen) {
        var token, fileUploadHeader, formattedValues, type, ref2, lands, attributes, formData;
        return _node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    token = js_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("token");
                    (axios__WEBPACK_IMPORTED_MODULE_1___default().defaults.headers.common.Authorization) = "Bearer ".concat(token);
                    fileUploadHeader = {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    };
                    formattedValues = {};
                    type = item.__typename;
                    if (item.__typename === "Parks") {
                        ;
                        formattedValues.Name = values.parkName;
                        lands = [];
                        values === null || values === void 0 ? void 0 : (ref2 = values.lands) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(land) {
                            var ref3, ref1;
                            if (!(land === null || land === void 0 ? void 0 : land.Name)) {
                                return false;
                            }
                            lands.push({
                                Name: land.Name,
                                Content: land.Content || "",
                                Attractions: (ref1 = land === null || land === void 0 ? void 0 : (ref3 = land.Attractions) === null || ref3 === void 0 ? void 0 : ref3.filter(function(attraction) {
                                    var ref;
                                    return !(attraction === null || attraction === void 0 ? void 0 : (ref = attraction.id) === null || ref === void 0 ? void 0 : ref.startsWith("--"));
                                })) === null || ref1 === void 0 ? void 0 : ref1.map(function(attraction) {
                                    return attraction.id;
                                })
                            });
                        });
                        formattedValues.Lands = lands;
                    }
                    if (item.__typename === "Attraction") {
                        type = "attractions";
                        formattedValues.Name = values.attractionName;
                        formattedValues.Type = values.attractionType || "OTHER";
                    }
                    if (item.__typename === "Resort") {
                        type = "resorts";
                        formattedValues.Name = values.resortName;
                    }
                    if (values.latitude !== undefined && values.longitude !== undefined) {
                        formattedValues.Location = {
                            Latitude: values.latitude || null,
                            Longitude: values.longitude || null
                        };
                    }
                    if (Array.isArray(values.attributes)) {
                        attributes = values.attributes.map(function(attribute) {
                            return {
                                ValueType: attribute.ValueType,
                                Value: attribute.Value || ""
                            };
                        });
                        formattedValues.Attribute = attributes;
                    }
                    if (typeof (values === null || values === void 0 ? void 0 : values.description) !== "undefined") {
                        formattedValues.Description = values.description;
                    }
                    if (!_instanceof(values.mainImage, File)) {
                        _ctx.next = 19;
                        break;
                    }
                    formData = new FormData();
                    formData.append("files", values.mainImage);
                    formData.append("ref", item.__typename);
                    formData.append("refId", item.id);
                    formData.append("field", "MainPhoto");
                    _ctx.next = 19;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat(utils_const__WEBPACK_IMPORTED_MODULE_4__/* .API_URL */ .T5, "/upload"), formData, fileUploadHeader);
                case 19:
                    _ctx.next = 21;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default().put("".concat(utils_const__WEBPACK_IMPORTED_MODULE_4__/* .API_URL */ .T5, "/").concat(type, "/").concat(item.id), formattedValues);
                case 21:
                    // update cache
                    if (type === "attractions") {
                        (0,swr__WEBPACK_IMPORTED_MODULE_3__/* .mutate */ .JG)((0,swr__WEBPACK_IMPORTED_MODULE_3__/* .unstable_serialize */ .wE)([
                            queries_attraction__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
                            {
                                slug: item.Slug
                            }
                        ]));
                    }
                    if (type === "resorts") {
                        (0,swr__WEBPACK_IMPORTED_MODULE_3__/* .mutate */ .JG)((0,swr__WEBPACK_IMPORTED_MODULE_3__/* .unstable_serialize */ .wE)([
                            queries_resort__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
                            {
                                slug: item.Slug
                            }
                        ]));
                    }
                    if (type === "Parks") {
                        (0,swr__WEBPACK_IMPORTED_MODULE_3__/* .mutate */ .JG)((0,swr__WEBPACK_IMPORTED_MODULE_3__/* .unstable_serialize */ .wE)([
                            queries_park__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
                            {
                                slug: item.Slug
                            }
                        ]));
                    }
                    if (typeof setOpen === "function") {
                        setOpen(false);
                    }
                    setSubmitting(false);
                case 26:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _saveEdit.apply(this, arguments);
}


/***/ }),

/***/ 49969:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contents":"card_contents__EHihQ"};

/***/ }),

/***/ 14102:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cover":"cover_cover__vrnbK","figure":"cover_figure__nguT5","caption":"cover_caption__vmK9W","titleBg":"cover_titleBg__7vBwg"};

/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(97345)


/***/ }),

/***/ 25575:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function HomeIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(HomeIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [533,529,774,888,179], function() { return __webpack_exec__(43503); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);